<template>
  <el-container
    v-if="isFetchMenu"
    style="height: 100%;"
    direction="vertical">
    <layout-header />
    <el-container>
      <layout-sider />
      <layout-main />
    </el-container>
  </el-container>
</template>

<script>
import LayoutHeader from '../components/layout/layout-header.vue'
import LayoutSider from '../components/layout/layout-sider.vue'
import LayoutMain from '../components/layout/layout-main.vue'
export default {
  name: 'Index',
  components: { LayoutHeader, LayoutSider, LayoutMain },
  data() {
    return { isFetchMenu: false }
  },
  mounted() {
    this.$store.dispatch('account/getMenuList', {
      success: (url, menuList) => {
        if (!menuList.includes(this.$route.meta.activePath)) {
          this.$router.replace({ path: url })
        }
        this.isFetchMenu = true
      }
    })
  }
}
</script>
<style lang="stylus"></style>
